(() => {
  if (window.cartDrawerUpsellInitialized) {
    return;
  }

  window.cartDrawerUpsellInitialized = true;

  const resetButton = (button, delay = 1500) => {
    window.setTimeout(() => {
      if (!button.isConnected) {
        return;
      }

      button.textContent = "ADD TO CART";
      button.disabled = false;
    }, delay);
  };

  document.addEventListener("change", (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const select = event.target.closest(".upsell-variant-select");
    if (!select) {
      return;
    }

    const card = select.closest(".upsell-card");
    const image = card?.querySelector(".upsell-image img");
    const selectedOption = select.options[select.selectedIndex];
    const newSource = selectedOption?.dataset.image;

    if (image && newSource) {
      image.src = newSource;
      image.removeAttribute("srcset");
    }
  });

  document.addEventListener("click", async (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const button = event.target.closest(".upsell-add-btn");
    if (!button || button.disabled) {
      return;
    }

    const card = button.closest(".upsell-card");
    const variantSelect = card?.querySelector(".upsell-variant-select");
    const variantInput = card?.querySelector(".upsell-variant-id");
    const variantId = variantSelect?.value || variantInput?.value;

    if (!variantId) {
      console.error("[Upsell] No variant ID found for card:", card);
      return;
    }

    button.textContent = "ADDING";
    button.disabled = true;

    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections }
      }));

      const rootUrl = window.Shopify?.routes?.root || "/";
      const formData = new FormData();
      formData.set("id", variantId);
      formData.set("quantity", "1");
      formData.set("sections", sections.join(","));
      formData.set("sections_url", `${rootUrl}variants/${variantId}`);

      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData
      });
      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || `Add to cart failed: ${response.status}`);
      }

      const cart = await fetch(`${rootUrl}cart.js`, { cache: "no-store" }).then((cartResponse) => cartResponse.json());
      cart.sections = responseJson.sections;

      button.textContent = "ADDED";

      if (cart.sections) {
        button.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart
          }
        }));
      } else {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }

      resetButton(button);
    } catch (error) {
      console.error("[Upsell] Error:", error);
      button.textContent = "ERROR";
      resetButton(button, 2000);
    }
  });
})();
